import { useEffect, useState } from "react";
import { ResponsiveContainer } from "recharts";
import { GET_ACCESS_STATUS_SUMMARY_REPORT } from "../../../graphql/queries";
import { useLazyQuery } from "@apollo/client";
import PieChartWithActive from "./components/PieChartWithActive";
import RecordsModal from "../RecordsModal";

export default function AccessStatusSummaryChart() {
   const [data, setData] = useState<any[]>([]);
   const [selectedStatus, setSelectedStatus] = useState<string | null>(null);
   const [getAccessStatusSummary, { loading }] = useLazyQuery(GET_ACCESS_STATUS_SUMMARY_REPORT, {
      fetchPolicy: "no-cache",
   });

   useEffect(() => {
      getAccessStatusSummary().then(res => {
         setData(() => {
            return (res.data?.getAccessStatusSummary || []).map((i: any) => {
               let color = i.status === 'Access_Granted' ? '#33FF33' : i.status === 'Access_Denied' ? '#FF3333' : '#3333FF';
               return ({ name: i.status, value: i.count, color: color, code: i.status });
            });
         });
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   return (
      <div style={{ width: "100%", height: 420 }} className="border bottom-1 rounded p-2">
         <h3 style={{ textAlign: "center" }}>Access Status Summary</h3>
         {loading && <p>Loading ....</p>}
         <ResponsiveContainer>
            <PieChartWithActive
               data={data}
               onSliceClick={(e) => e?.code && setSelectedStatus(e.code)}
            />
         </ResponsiveContainer>
         {selectedStatus && (
            <RecordsModal
               title={`Records: ${selectedStatus}`}
               filter={{ status: [selectedStatus] }}
               onClose={() => setSelectedStatus(null)}
            />
         )}
      </div>
   );
}
